import SignalCellular1BarIcon from "@mui/icons-material/SignalCellular1Bar";
import SignalCellular2BarIcon from "@mui/icons-material/SignalCellular2Bar";
import SignalCellular3BarIcon from "@mui/icons-material/SignalCellular3Bar";
import SignalCellular4BarIcon from "@mui/icons-material/SignalCellular4Bar";
import SignalCellularNoBarIcon from "@mui/icons-material/SignalCellularConnectedNoInternet0Bar";

const SignalIcon = ({ signalBars }: { signalBars: string }) => {
    const level = Number(signalBars);
    return (
        level === 0 ?
            <SignalCellularNoBarIcon fontSize="large" sx={{color: "red", transform: "scale(2)"}}/>
        : level === 1 ?
            <SignalCellular1BarIcon fontSize="large" sx={{color: "red", transform: "scale(2)"}}/>
        : level === 2 ?
            <SignalCellular1BarIcon fontSize="large" sx={{color: "orange", transform: "scale(2)"}}/>
        : level === 3 ?
            <SignalCellular2BarIcon fontSize="large" sx={{color: "yellow", transform: "scale(2)"}}/>
        : level === 4 ?
            <SignalCellular3BarIcon fontSize="large" sx={{color: "limegreen", transform: "scale(2)"}}/>
        : level >= 5 ?
            <SignalCellular4BarIcon fontSize="large" sx={{color: "limegreen", transform: "scale(2)"}}/>
        : // signalBars is negative
            <SignalCellularNoBarIcon fontSize="large" sx={{color: "grey", transform: "scale(2)"}}/>
    );
};

export default SignalIcon;